import React, { useEffect, useState } from 'react'
import Modal from 'react-responsive-modal'
import Button from '../../../components/Button'
import { useFormik } from 'formik'
import styles from '../styles.module.scss'

const initialValues = {
  videoDeviceId: '',
  audioDeviceId: ''
}

const ConnectModal = ({ streamActive, connectStream }) => {
  
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  const [microphoneOptions, setMicrophoneOptions] = useState([])
  const [cameraOptions, setCameraOptions] = useState([])

  useEffect(() => {
    gettUserMedia();
  }, []);


  const onSubmit = async () => {
    connectStream(values)
    setOpen(false)
  }

  const {values, handleChange, setFieldValue, handleSubmit} = useFormik({ initialValues, onSubmit })


  const gettUserMedia = async () => {
    setLoading(true)
    await navigator.mediaDevices.getUserMedia({ audio: true, video: true})
    const mediaDevices = await navigator.mediaDevices.enumerateDevices();
    const microPhones = mediaDevices.filter(device => device.kind === 'audioinput')
    const cameras = mediaDevices.filter(device => device.kind === 'videoinput')
    setLoading(false)
    
    setMicrophoneOptions(microPhones)
    setCameraOptions(cameras)

    setFieldValue('audioDeviceId', microPhones[0]?.deviceId)
    setFieldValue('videoDeviceId', cameras[0]?.deviceId)
  }

  const closeModal = () => setOpen(false)

  return (
    <>
      {!streamActive && <Button onClick={() => setOpen(true)}>Подключиться</Button>}
      <Modal
        open={open}
        onClose={closeModal}
        classNames={{modal: styles.connectModal}}
        showCloseIcon={false}
        center
      >
        <div>
          <p className={styles.labels}>Микрофон:</p>
          <select
            className={styles.formControl}
            name='audioDeviceId'
            value={values.audioDeviceId}
            onChange={handleChange}
          >
            <option value="" >Без микрофона</option>
            {microphoneOptions?.map((e) => (
              <option key={e.deviceId} value={e.deviceId}>
                {e.label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <p className={styles.labels}>Камера:</p>
          <select
            className={styles.formControl}
            name='videoDeviceId'
            value={values.videoDeviceId}
            onChange={handleChange}
          >
            <option value="">Без камеры</option>
            {cameraOptions?.map((e) => (
              <option key={e.deviceId} value={e.deviceId}>
                {e.label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <Button disabled={loading} onClick={handleSubmit}>Подключиться</Button>
          <Button onClick={closeModal}>Отмена</Button>
        </div>
      </Modal>
    </>
  )
}

export default ConnectModal